import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_501: DocMigration = {
  maxSchemaVersion: "0.0.501",
  description: "Add viewFilter to elevation views and section views",
  apply(json: any): any {
    // viewFilter needs to be initialized as an empty object so that new tag creation works.
    for (const id of Object.keys(json.elevationViews)) {
      json.elevationViews[id].viewFilter = {};
    }
    for (const id of Object.keys(json.sectionViews)) {
      json.sectionViews[id].viewFilter = {};
    }

    return json;
  },
};

export default migration_0_0_501;
